import { LocalizationSetting } from '../types/localization-setting';
import { LocalizationStateModel } from '../types/localization-state';

export class SelectLanguage {
  static readonly type = '[Localization] SelectLanguage';
  constructor(public lang: LocalizationStateModel['lang']) {}
}

/** Apply full org-unit localization (locale, currency, date/time format). Lang is derived from setting locale with user preference override. */
export class ApplyLocalizationSetting {
  static readonly type = '[Localization] ApplyLocalizationSetting';
  constructor(
    public readonly localizationSetting?:
      | LocalizationSetting
      | null
      | undefined,
  ) {}
}
